









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { 商品区分型 } from '@/type/master/item';

@Component({})
export default class ItemClassSelector extends Vue {
  @Prop({default: null})
  private value!: 商品区分型;

  @Emit('input')
  private update(event: Event): 商品区分型 | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
        return target.value as 商品区分型;
    }
    return null;
  }
}
